// ISO-3166 alpha-2 country code -> ISO-4217 currency code.
// Not exhaustive of every micro-territory; unmapped countries fall back to DEFAULT_CURRENCY.
export const DEFAULT_CURRENCY = 'USD';

export const COUNTRY_TO_CURRENCY = {
  // North America
  US: 'USD', PR: 'USD', GU: 'USD', VI: 'USD', AS: 'USD', MP: 'USD',
  CA: 'CAD',
  MX: 'MXN',

  // Central America & Caribbean
  GT: 'GTQ', BZ: 'BZD', HN: 'HNL', SV: 'USD', NI: 'NIO', CR: 'CRC', PA: 'USD',
  CU: 'CUP', DO: 'DOP', HT: 'HTG', JM: 'JMD', TT: 'TTD', BB: 'BBD', BS: 'BSD',
  BM: 'BMD', KY: 'KYD', AG: 'XCD', DM: 'XCD', GD: 'XCD', KN: 'XCD', LC: 'XCD',
  VC: 'XCD', AW: 'AWG', CW: 'ANG', SX: 'ANG', TC: 'USD',

  // South America
  CO: 'COP', VE: 'VES', EC: 'USD', PE: 'PEN', BO: 'BOB', PY: 'PYG', UY: 'UYU',
  CL: 'CLP', AR: 'ARS', BR: 'BRL', SR: 'SRD', GY: 'GYD', FK: 'FKP',

  // Europe (Eurozone)
  AT: 'EUR', BE: 'EUR', CY: 'EUR', EE: 'EUR', FI: 'EUR', FR: 'EUR', DE: 'EUR',
  GR: 'EUR', IE: 'EUR', IT: 'EUR', LV: 'EUR', LT: 'EUR', LU: 'EUR', MT: 'EUR',
  NL: 'EUR', PT: 'EUR', SK: 'EUR', SI: 'EUR', ES: 'EUR', AD: 'EUR', MC: 'EUR',
  SM: 'EUR', VA: 'EUR', ME: 'EUR', XK: 'EUR', HR: 'EUR',

  // Europe (non-Eurozone)
  GB: 'GBP', IM: 'GBP', JE: 'GBP', GG: 'GBP', GI: 'GIP',
  CH: 'CHF', LI: 'CHF',
  NO: 'NOK', SE: 'SEK', DK: 'DKK', FO: 'DKK', GL: 'DKK', IS: 'ISK',
  PL: 'PLN', CZ: 'CZK', HU: 'HUF', RO: 'RON', BG: 'BGN',
  RS: 'RSD', MK: 'MKD', AL: 'ALL', BA: 'BAM',
  RU: 'RUB', BY: 'BYN', UA: 'UAH', MD: 'MDL',

  // Middle East
  TR: 'TRY', GE: 'GEL', AM: 'AMD', AZ: 'AZN',
  IL: 'ILS', JO: 'JOD', LB: 'LBP', SY: 'SYP', IQ: 'IQD', IR: 'IRR',
  SA: 'SAR', AE: 'AED', QA: 'QAR', OM: 'OMR', BH: 'BHD', KW: 'KWD', YE: 'YER',

  // Central & South Asia
  KZ: 'KZT', UZ: 'UZS', TJ: 'TJS', KG: 'KGS', TM: 'TMT', AF: 'AFN',
  IN: 'INR', PK: 'PKR', BD: 'BDT', LK: 'LKR', NP: 'NPR', BT: 'BTN', MV: 'MVR',

  // East & Southeast Asia
  CN: 'CNY', HK: 'HKD', TW: 'TWD', JP: 'JPY', KR: 'KRW', MN: 'MNT', MO: 'MOP',
  ID: 'IDR', MY: 'MYR', SG: 'SGD', TH: 'THB', VN: 'VND', PH: 'PHP', MM: 'MMK',
  KH: 'KHR', LA: 'LAK', BN: 'BND',

  // Africa
  EG: 'EGP', LY: 'LYD', TN: 'TND', DZ: 'DZD', MA: 'MAD', MR: 'MRU', SD: 'SDG',
  SS: 'SSP', ET: 'ETB', ER: 'ERN', DJ: 'DJF', SO: 'SOS', KE: 'KES', TZ: 'TZS',
  UG: 'UGX', RW: 'RWF', BI: 'BIF', NG: 'NGN', GH: 'GHS', CI: 'XOF', SN: 'XOF',
  ML: 'XOF', BF: 'XOF', NE: 'XOF', TG: 'XOF', BJ: 'XOF', GW: 'XOF',
  CM: 'XAF', GA: 'XAF', CG: 'XAF', TD: 'XAF', CF: 'XAF', GQ: 'XAF',
  ZA: 'ZAR', LS: 'LSL', NA: 'NAD', SZ: 'SZL', BW: 'BWP', ZM: 'ZMW', ZW: 'ZWL',
  MW: 'MWK', MZ: 'MZN', AO: 'AOA', CD: 'CDF', GM: 'GMD', GN: 'GNF', LR: 'LRD',
  SL: 'SLE', CV: 'CVE', ST: 'STN', MG: 'MGA', KM: 'KMF', SC: 'SCR', MU: 'MUR',

  // Oceania
  AU: 'AUD', NZ: 'NZD', FJ: 'FJD', PG: 'PGK', SB: 'SBD', VU: 'VUV', WS: 'WST',
  TO: 'TOP', KI: 'AUD', NR: 'AUD', TV: 'AUD', PF: 'XPF', NC: 'XPF', WF: 'XPF',
};

export function getCurrencyForCountry(countryCode) {
  if (!countryCode) return DEFAULT_CURRENCY;
  return COUNTRY_TO_CURRENCY[countryCode.toUpperCase()] || DEFAULT_CURRENCY;
}

export default COUNTRY_TO_CURRENCY;
